import { Link } from "react-router-dom";
import { ArrowRight, ClipboardCheck, Handshake, Layers, MapPin, Thermometer, Wrench } from "lucide-react";
import { MediaImage } from "../MediaImage";
import { useSiteMedia } from "../../lib/siteMedia";
import { WHY_POINTS } from "../../data/homeContent";
import { SectionHeading } from "./CtaButtons";

const ICONS = { Handshake, Wrench, Layers, Thermometer, MapPin, ClipboardCheck };
const STEPS = ["Inmeten", "Demontage", "Levering", "Montage", "Afwerking"];

// Complete levering en montage in vijf stappen, met link naar de volledige werkwijze.
const Steps = () => (
  <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5" data-testid="home-why-steps">
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-2 text-[14px] font-semibold text-ink">
      {STEPS.map((s, i) => (
        <li key={s} className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-maas-soft text-[13px] font-bold text-maas">{i + 1}</span>{s}
          {i < STEPS.length - 1 && <ArrowRight className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" />}
        </li>
      ))}
    </ol>
    <Link to="/werkwijze" className="mt-3 inline-flex items-center gap-1.5 text-[14px] font-semibold text-maas hover:underline" data-testid="home-why-werkwijze">Bekijk onze werkwijze <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
  </div>
);

export const WhyMaas = ({ block }) => {
  const media = useSiteMedia();
  return (
    <section aria-labelledby="why-title" className="section" data-testid="home-why">
      <div className="container-tight grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="relative lg:col-span-5">
          <div className="frame">
            <MediaImage media={media("why_image")} sizes="(min-width: 1024px) 460px, calc(100vw - 32px)" className="aspect-[4/3] rounded-[14px] lg:aspect-[4/5]" testId="why-image" />
          </div>
          <blockquote className="card absolute -bottom-6 right-4 hidden max-w-[250px] p-5 sm:block lg:-right-6" style={{ boxShadow: "var(--shadow-2)" }}>
            <p className="font-display text-[17px] font-semibold leading-snug text-ink">Kunststof voor comfort. Aluminium voor architectuur.</p>
            <p className="mt-2 text-[13px] text-slate-500">Vakmanschap in de montage.</p>
          </blockquote>
        </div>
        <div className="lg:col-span-7">
          <SectionHeading id="why-title" eyebrow="Waarom Maas Kozijn" title={block.title} lead={block.body} />
          <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2">
            {WHY_POINTS.map((w) => {
              const Icon = ICONS[w.icon];
              return (
                <li key={w.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><Icon className="h-5 w-5" aria-hidden="true" /></span>
                  <div>
                    <h3 className="text-[17px] font-semibold text-ink">{w.title}</h3>
                    <p className="mt-1.5 text-[14.5px] leading-relaxed text-slate-600">{w.text}</p>
                  </div>
                </li>
              );
            })}
          </ul>
          <Steps />
        </div>
      </div>
    </section>
  );
};
